import fetch from './communityFetch';

const getBanner = params => fetch({ url: '/banner', params });
const addBanner = ({ params }) => fetch({ url: '/banner', params, methold: 'post' });
const editBanner = ({ banner_id, params }) => fetch({ url: `/banner/${banner_id}`, params, methold: 'put' });
const delBanner = ({ params }) => fetch({ url: '/banner/batch_delete', params, methold: 'delete' });
const bannedUser = ({ community_users_id }) => fetch({ url: `/banned_user/${community_users_id}`, methold: 'post' });
const unblockUser = ({ community_users_id }) => fetch({ url: `/unblock_user/${community_users_id}`, methold: 'post' });
const cUpload = config =>
  fetch({
    url: '/upload/banner',
    methold: 'post',
    config
  });
const sysInfo = ({ params, methold }) => fetch({ url: '/sys_info', params, methold });

export default {
  sysInfo,
  delBanner,
  addBanner,
  cUpload,
  getBanner,
  editBanner,
  bannedUser,
  unblockUser
};
